import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { Title, RowCustom, ButtonLink, ContainerCustom } from 'components';

import {
  CardPopularWrapper,
  CardPopularOverlay,
  CardPopular,
  CardPopularInfo,
} from '../Main.styles';

const PopularDirectionsScroll = ({ dataPopular }) => {
  const intl = useIntl();
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(null);
  const [scrollLeft, setScrollLeft] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const slider = useRef(null);

  const mouseDownHandler = (e) => {
    setIsDown(true);
    setIsActive(true);
    setStartX(e.pageX - slider.current.offsetLeft);
    setScrollLeft(slider.current.scrollLeft);
    console.dir('mouseDown', slider.current);
  };

  const mouseLeaveHandler = () => {
    setIsDown(false);
    setIsActive(false);
  };

  const mouseUpHandler = () => {
    setIsDown(false);
    setIsActive(false);
  };

  const mouseMoveHandler = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.current.offsetLeft;
    const walk = (x - startX) * 2; //scroll-fast
    slider.current.scrollLeft = scrollLeft - walk;
    console.log(walk);
  };

  return (
    <div>
      <ContainerCustom
        isActive={isActive}
        padding="0"
        paddingTablet="0 0 0 5.7vw"
        display="flex"
        wrap="no-wrap"
        overflowX="scroll"
        ref={slider}
        onMouseDown={mouseDownHandler}
        onMouseLeave={mouseLeaveHandler}
        onMouseUp={mouseUpHandler}
        onMouseMove={mouseMoveHandler}
      >
        {dataPopular &&
          dataPopular.featuredRegions.map(
            ({ country, coverPhoto, name, url, propertiesCount, price }, i) => (
              <div style={{ marginRight: '12px' }}>
                <CardPopularWrapper>
                  <Link to={`${url}`} target="_blank">
                    <CardPopular
                      bgImg={`${process.env.REACT_APP_API_MEDIA_URL}${coverPhoto}`}
                      width="30vw"
                      height="25vw"
                      widthM="50vw"
                      heightM="40vw"
                    >
                      <CardPopularOverlay />
                      <CardPopularInfo paddingM="30px 30px 20px 20px">
                        <Title size1100="18px" size="24px" color="#fff">
                          {name}
                          {/* {', '} */}
                          {country}
                        </Title>
                        <RowCustom justify="space-between" width="100%">
                          <Title
                            opacity="0.5"
                            size1100="12px"
                            size="14px"
                            color="#fff"
                          >
                            {propertiesCount}{' '}
                            {intl.formatMessage({
                              id:
                                'main-page.popular-direction-card.appartments',
                            })}
                          </Title>
                          {/* <Title size="12px" color="#fff">
                            {intl.formatMessage({
                              id: 'main-page.popular.price-from',
                            })}
                            {price} €
                          </Title> */}
                        </RowCustom>
                      </CardPopularInfo>
                    </CardPopular>
                  </Link>
                </CardPopularWrapper>
              </div>
            )
          )}
      </ContainerCustom>
      {/* <ButtonLink
        display="flex"
        align="center"
        justify="center"
        size="16px"
        width="144px"
        height="54px"
        sizeM="14px"
        margin="0 auto 0 auto"
        marginSM="28px auto 0 auto"
        primary
        target="blank"
        to={`${localStorage.language}/destinations`}
      >
        {intl.formatMessage({
          id: 'buttons.all-directions',
        })}
      </ButtonLink> */}
    </div>
  );
};

export { PopularDirectionsScroll };
